<template>
    <jet-form-section @submitted="updatePassword">
        <template #title>
            Update Password
        </template>

        <template #description>
            Ensure your account is using a long, random password to stay secure.
        </template>

        <template #form>
            <div class="col-span-6 sm:col-span-4">
                <jet-label for="current_password" value="Current Password" />
                <jet-input id="current_password" type="password" class="mt-1 block w-full" v-model="form.current_password" ref="current_password" autocomplete="current-password" />
                <jet-input-error :message="fieldError('current_password')" class="mt-2" />
            </div>

            <div class="col-span-6 sm:col-span-4">
                <jet-label for="password" value="New Password" />
                <jet-input id="password" type="password" class="mt-1 block w-full" v-model="form.password" autocomplete="new-password" />
                <jet-input-error :message="fieldError('password')" class="mt-2" />
            </div>

            <div class="col-span-6 sm:col-span-4">
                <jet-label for="password_confirmation" value="Confirm Password" />
                <jet-input id="password_confirmation" type="password" class="mt-1 block w-full" v-model="form.password_confirmation" autocomplete="new-password" />
                <jet-input-error :message="fieldError('password_confirmation')" class="mt-2" />
            </div>
        </template>

        <template #actions>
            <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                Saved.
            </jet-action-message>

            <!-- <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Save
            </jet-button> -->
            <v-btn :class="{ 'opacity-25': form.processing }" :disabled="form.processing" type="submit" color="primary">
               Save
            </v-btn>
        </template>
    </jet-form-section>
</template>

<script>
import JetActionMessage from '@/Jetstream/ActionMessage'
import JetButton from '@/Jetstream/Button'
import JetFormSection from '@/Jetstream/FormSection'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'

export default {
   components: {
      JetActionMessage,
      JetButton,
      JetFormSection,
      JetInput,
      JetInputError,
      JetLabel,
   },

   data() {
      return {
         form: {
            current_password: '',
            password: '',
            password_confirmation: '',
            processing: false,
            recentlySuccessful: false,
         },
         formErrors: {},
      }
   },

   methods: {
      fieldError(field) {
         return this.formErrors[field] || '';
      },

      updatePassword() {
         this.form.processing = true
         this.form.recentlySuccessful = false
         this.formErrors = {}

         this.$inertia.put(route('user-password.update'), {
            current_password: this.form.current_password,
            password: this.form.password,
            password_confirmation: this.form.password_confirmation,
         }, {
            preserveScroll: true,
            onError: (errors) => {
               this.formErrors = errors || {}
               this.$refs.current_password.focus()
            },
            onSuccess: () => {
               this.form.recentlySuccessful = true
               this.form.current_password = ''
               this.form.password = ''
               this.form.password_confirmation = ''
               this.$refs.current_password.focus()
            },
            onFinish: () => {
               this.form.processing = false
            },
         })
      },

      formError(field) {
         if (this.form && typeof this.form.error === 'function') {
            return this.form.error(field)
         }

         return (this.form && this.form.errors && this.form.errors[field]) || null
      },
   },
}
</script>
